export const sliderItems=[
    {
        id:1,
        src:'./pictures/img1.jpg',
        title:"WINTER SALE",
        desc:"BEGIN THIS NEW YEAR WITH THE LATEST MOBILE PHONES ! GET UPTO 30% OFF",
        bg:"e6809b",
    },
    {
        id:2,
        src:'./pictures/img5.jpg',
        title:"SUMMER SALE",
        desc:"BEGIN THIS NEW YEAR WITH THE LATEST MOBILE PHONES ! GET UPTO 30% OFF",
        bg:"fbf0f4",
        
    },
    {
        id:3,
        src:'./pictures/img3.jpg',
        title:"WEEKEND SALE",
        desc:"BEGIN THIS NEW YEAR WITH THE LATEST MOBILE PHONES ! GET UPTO 30% OFF",
        bg:"fcf1ed",
        
    },
    
];

export const categories=[
    {
        id:1,
        img:'./pictures/cat1.jpg',
        title:"VIVO",
        cat:"vivo"

    },

    {
        id:2,
        img:'./pictures/cat2.jpg',
        title:"SAMSUNG",
        cat:"samsung"

    },

    {
        id:3,
        img:'./pictures/cat3.jpg',
        title:"ONE PLUS",
        cat:"one plus"

    },
];


export const popularProducts=[
    {
        id:1,
        img:'./pictures/pro11.jpg',
    },

    {
        id:2,
        img:'./pictures/pro2.jpg',
    },
    {
        id:3,
        img:'./pictures/pro9.jpg',
    },
    {
        id:4,
        img:'./pictures/pro4.jpg',
    },
    {
        id:5,
        img:'./pictures/pro10.jpg',
    },
    {
        id:6,
        img:'./pictures/pro6.jpg',
    },
    {
        id:7,
        img:'./pictures/pro7.jpg',
    },
    {
        id:8,
        img:'./pictures/pro8.jpg',
    },

];